import { useMemo } from 'react';

import type { PointGetCardsFilters } from '@vlabs/api/types';

import { useCardsFilters } from './useCardsFilters';
import { FIO_FILTER_KEY } from './utils';

export function useWildcardCardListFiltersValue(): PointGetCardsFilters {
  const { filters } = useCardsFilters();
  return useMemo(() => ({
    ...filters,
    [FIO_FILTER_KEY]: (filters[FIO_FILTER_KEY]?.length ?? 0) > 0 ? `%${filters[FIO_FILTER_KEY]}%` : undefined,
  }), [filters]);
}
